module.exports = __webpack_public_path__ + "static/media/music.a5854e58.png";